module.exports = __webpack_public_path__ + "img/leadership.867c9383.png";